import { render, staticRenderFns } from "./MarketplaceSummary.vue?vue&type=template&id=634f2077&scoped=true&"
import script from "./MarketplaceSummary.vue?vue&type=script&lang=js&"
export * from "./MarketplaceSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "634f2077",
  null
  
)

export default component.exports